import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { FechaSegunPeriodoInput } from 'sharedComponents/inputs/date'

import { KeyEventUtil } from 'utils'

const FechaDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('button-continuar', e, {
      timeOutTime: 200
    })
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FEC DOC' htmlFor='inputDate-fechaDocumento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaDocumento'>
          {({ field }) => (
            <FechaSegunPeriodoInput
              {...field}
              id='inputDate-fechaDocumento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaDocumentoFormGroup)
